import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'cv-objective-assign',
  templateUrl: './objective-assign.component.html',
  styleUrls: ['./objective-assign.component.scss']
})
export class ObjectiveAssignComponent implements OnInit {
    @Input() showall: boolean = true;
    @Input() lst: any[];
    @Input() onremove;
    @Input() empgrouptypes;
    @Input() recgrouptypes;
    @Input() dataoptions;
    @Input() empAssignAll;
    @Input() recAssignAll;

    @Output() AssignToolObjectiveSaveEvt = new EventEmitter<any>();

    empLevelSelected:number = 0;
    recLevelSelected:number = 0;
    assignToLevel:number = 0;
    assignToType:string = null;

    constructor() { }

    ngOnInit(): void {}

    empSelected() {
        for (let item of this.lst) {
            if (item.BaseGroupType == 0)
                return true;
        }

        return false;
    }

    recSelected() {
        for (let item of this.lst) {
            if (item.BaseGroupType == 1)
                return true;
        }

        return false;
    }

    onRemove(obj) {
        this.onremove(obj, null);

        this.updateAssignTo();
    }

    updateAssignTo() {
        let empFound = false;
        let recFound = false;

        for (let item of this.lst) {
            if (!empFound && item.BaseGroupType == 0) {
                empFound = true;
                this.empLevelSelected = item.GroupLevel;
            }
            else if (!recFound && item.BaseGroupType == 1) {
                recFound = true;
                this.recLevelSelected = item.GroupLevel;
            }

            if (empFound && recFound)
                break;
        }

        // If all of a side is removed and that side was used for the assignTo dropdown then clear the dropdown as well so you dont have a selection that is not valid
        if (!empFound) {
            this.empLevelSelected = 0;

            if (this.assignToType == "emp") {
                this.assignToLevel = 0;
                this.assignToType = null;
            }
        }

        if (!recFound) {
            this.recLevelSelected = 0;

            if (this.assignToType == "rec") {
                this.assignToLevel = 0;
                this.assignToType = null;
            }
        }

        if (this.assignToType == null && !empFound && this.showall) { // If normalized metric but they add a rec first then still assign to the emp side (since the user cannot see this selction)
            this.assignToType = "emp";
            this.assignToLevel = 6;
        }

        // If assign to input is empty (either first add or removal of the selected side) then try to set it to the other side if available
        // If assigned to all emp and a emp group is added then update to that level.
        if ((this.assignToType == null && empFound) || (empFound && this.showall && this.assignToLevel == 6)) {
            this.assignToType = "emp";
            this.assignToLevel = this.empLevelSelected;
        }
        else if (this.assignToType == null && recFound) {
            this.assignToType = "rec";
            this.assignToLevel = this.recLevelSelected;
        }
    }

    AssignToolUpdateObjectiveEvt() {
        this.assignToLevel = 0;
        this.assignToType = null;
        this.empLevelSelected = 0;
        this.recLevelSelected = 0;
    }

    AssignToolGroupCountEvt(data) {
        if (data.ParentGroupID == null) return;

        this.updateAssignTo();
    }

    AssignToolButtonEvt() {
        // Double check with on desired save functionality
        let empFound = false;
        let recFound = false;
        if (!this.showall) { // Require a selection for both emp and rec

            for (let item of this.lst) {
                if (item.BaseGroupType == 0)
                    empFound = true;
                else if (item.BaseGroupType == 1)
                    recFound = true;

                if (empFound && recFound)
                    break;
            }

            if ((!empFound && !this.empAssignAll) || (!recFound && !this.recAssignAll)) {
                window["showErrorDialog"]("Please add an emp and rec group before assigning.", "Error, Groups are Required");
                return;
            }

            if (this.dataoptions.coreAssignAtOption == 'parent') {
                if ((this.dataoptions.coreAssignAtType == 'emp' && this.dataoptions.coreAssignAtLevel >= this.empLevelSelected) ||
                    (this.dataoptions.coreAssignAtType == 'rec' && this.dataoptions.coreAssignAtLevel >= this.recLevelSelected)) {
                    window["showErrorDialog"]("Due to a previous selection you must choose groups higher than what is currently selected.", "Error, Parent Group Required");
                    return;
                }
            }

            if (this.dataoptions.coreAssignAtOption == 'specific') {
                if ((this.dataoptions.coreAssignAtType == 'emp' && this.dataoptions.coreAssignAtLevel != this.empLevelSelected) ||
                    (this.dataoptions.coreAssignAtType == 'rec' && this.dataoptions.coreAssignAtLevel != this.recLevelSelected)) {
                    window["showErrorDialog"]("Due to a previous selection, you must choose groups from the assigned level.", "Error, Same Level Groups Required");
                    return;
                }
            }
        }
        else {
            // Update the AssignType and AssignLevel for normalized
            if (this.lst.length == 0) {
                this.dataoptions.coreAssignAtType = "emp";
                this.dataoptions.coreAssignAtLevel = 6;
            }
            else {
                for (let item of this.lst) {
                    if (item.BaseGroupType == 0) {
                        this.dataoptions.coreAssignAtType = "emp";
                        this.dataoptions.coreAssignAtLevel = item.GroupLevel;
                        break;
                    }
                    else if (item.BaseGroupType == 1) {
                        this.dataoptions.coreAssignAtType = "rec";
                        this.dataoptions.coreAssignAtLevel = item.GroupLevel;
                    }
                }
            }
        }

        this.AssignToolObjectiveSaveEvt.emit({ 'list': this.lst, 'type': this.dataoptions.coreAssignAtType, 'lvl': this.dataoptions.coreAssignAtLevel, 'empAssignAll': this.empAssignAll && !empFound, 'recAssignAll': this.recAssignAll && !recFound });
    }

    filteredLst(type) {
        if (type < 2) // Emp or Rec
            return this.lst.filter(l => l.BaseGroupType == type);
        else // Attribute
            return this.lst.filter(l => l.AttributeValueID != null);
    }
}
